import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { AttendanceLocal } from "../../../@types/attendance-local";
import { AxiosError } from "axios";
import { apisiseci } from "../../api";

export type AttendanceLocalUpdateData = Pick<
    AttendanceLocal,
    | "nome"
    | "bairro"
    | "endereco"
    | "cep"
    | "ativo"
    | "source"
    | "complemento"
> & {
    orgao_id: number;
    cidade_id: string;
};

export function useAttendanceLocalUpdate(slug: AttendanceLocal["slug_unidade"]) {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        AttendanceLocal,
        AxiosError<{ detail: string }>,
        AttendanceLocalUpdateData
    >({
        mutationKey: ["attendance-local", "update", slug],
        mutationFn: async (data: AttendanceLocalUpdateData) => {
            return apisiseci.put(
                `/cms/unidades/${slug}/`, data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
        },
        onSuccess: async () => {
            toast.success("Local de atendimento atualizado com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "details", slug],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "guiche", "service", "list"]
                }),
            ]);

            history.goBack();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.detail || "Algo deu errado, tente novamente!");
            console.log(error);
        },
    });

    return mutation;
}
